"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7704,7364],{

/***/ 57704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Auth_Next; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./utils/apiClient.ts
var apiClient = __webpack_require__(77364);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/Auth/useNext.ts






var schema = es/* object */.Ry({
    email: es/* string */.Z_().email().required()
}).required();
var useNext = function(onNext) {
    var ref = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema)
    }), register = ref.register, handleSubmit = ref.handleSubmit, setError = ref.setError, _formState = ref.formState, errors = _formState.errors, isDirty = _formState.isDirty;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(result) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apiClient/* apiClient.post */.x.post("/api/v1/auth/verify", result)
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.ok) {
                            if (res.data.exists) {
                                setError("email", {
                                    type: "custom",
                                    message: "email already exists."
                                });
                            } else {
                                // Auth Callback
                                onNext(result.email);
                            }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(result) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        register: register,
        handleSubmit: handleSubmit,
        errors: errors,
        isDirty: isDirty,
        onSubmit: onSubmit
    };
};
/* harmony default export */ var Auth_useNext = (useNext);

;// CONCATENATED MODULE: ./components/Auth/Next.tsx






var Errors = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9025).then(__webpack_require__.bind(__webpack_require__, 29025));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29025)
            ];
        }
    },
    suspense: true
});
var Next = function(param) {
    var onNext = param.onNext, onLogin = param.onLogin;
    var ref = Auth_useNext(onNext), handleSubmit = ref.handleSubmit, onSubmit = ref.onSubmit, errors = ref.errors, isDirty = ref.isDirty, register = ref.register;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-center flex flex-col gap-2 pb-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "text-2xl",
                        children: "Create a Free Account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-base",
                            children: [
                                "Signup with Your Email or",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function(e) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onLogin();
                                        },
                                        className: "text-blue-600 underline",
                                        children: "Log in"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            Object.values(errors).length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Errors, {
                    errors: Object.values(errors)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, register("email")), {
                            className: "border border-primary outline-none px-3 py-2 w-full",
                            type: "email",
                            required: true,
                            placeholder: "Email Address"
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            disabled: !isDirty,
                            className: "w-full px-6 py-2 bg-primary text-white",
                            children: "Next"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Auth_Next = (Next);


/***/ }),

/***/ 77364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ apiClient; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50196);

var apiClient = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.bungalowfinder.ca"
});
// export const apiClient = axios.create({
//   baseURL: "http://127.0.0.1:2000",
// });
apiClient.interceptors.request.use(function(config) {
    var token = localStorage.getItem("token");
    if (!token) return config;
    if (config.headers) {
        config.headers["Authorization"] = "Bearer ".concat(token);
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});
apiClient.interceptors.response.use(function(res) {
    var _res = {
        ok: true,
        data: res.data,
        status: res.status
    };
    return _res;
}, function(error) {
    var res = undefined;
    if (error.response) {
        var _message = [];
        _message.push(error.response.data.message);
        res = {
            status: error.response.status,
            error: "SERVER",
            message: _message,
            data: error.response.data,
            ok: false
        };
        if (res.status === 401) {
            localStorage.removeItem("token");
            window.dispatchEvent(new CustomEvent("unauth"));
        }
        return Promise.resolve(res);
    }
    if (error.request) {
        res = {
            status: 500,
            data: error.request,
            error: "CLIENT",
            message: error.message,
            ok: false
        };
        return Promise.resolve(res);
    }
    res = {
        status: 500,
        data: {},
        ok: false,
        error: "ANY",
        message: [
            "Internal Server Error"
        ]
    };
    return Promise.resolve(res);
});


/***/ })

}]);